import { render, staticRenderFns } from "./QrcodeConsent.vue?vue&type=template&id=187d6d2a&scoped=true&"
import script from "./QrcodeConsent.vue?vue&type=script&lang=js&"
export * from "./QrcodeConsent.vue?vue&type=script&lang=js&"
import style0 from "./QrcodeConsent.vue?vue&type=style&index=0&id=187d6d2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187d6d2a",
  null
  
)

export default component.exports